// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1EQlb","insightsList":"newBusinessInsightsMenu_insightsList__1dkOw","active":"newBusinessInsightsMenu_active__2_cDD"};